import { rprt } from "api/endpoints";
import { importView } from "../utils/misc";

const ReportList = importView("Report/List");
const ReportDetail = importView("Report/Detail");

const rptRoutes = {
  path: "/",
  children: [
    {
      path: rprt.reports,
      element: <ReportList />,
    },
    {
      path: `${rprt.report}/:id`,
      element: <ReportDetail />,
    },
  ],
};

export default rptRoutes;
